export { configs, type Configs } from './configs'
export { getGtmContainerIdForThemeBrand } from './gtm'
export { getFaviconLinksForThemeBrand, type FaviconLink } from './favicons'
